var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-tabs',{staticClass:"send-service-tabs",attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Express"}},[_c('express-tab')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }